<template>
  <div class="model_continer">
    <p class="dataAnalysisTitle">福安茶叶生产模型预测</p>
    <p
      class="introl"
    >简介：系统采用灰色模型进行预测分析，灰色模型就是通过少量的、不完全的信息，建立灰色微分预测模型，对事物的发展规律作出模糊性的长期描述（模糊预测领域中理论、方法较为完善的预测学分支）。</p>
    <!-- <p
      class="introl"
    >投入单产、管理单产、生产决策模型、中长期产量模型：通过福安茶叶产量和投入要素进行灰色关联度分析（影响要素：区域、年份、产量、面积、气象、固定资本投入、劳动投入、投入肥料和农药）；</p> -->
    <p class="introl">
      灰度模型公式：
      <span
        style="font-family: serif;"
      >x(0)p(k)=(ba2−x(0)(1)a)(1−ea)e−a(k−1)+ba for k≥2,x(0)p(1)=x(0)(1)</span>
    </p>
    <p class="modelApplyLittleTitle">
      <span>第1步：</span>
      <span>选择预测数据的关键指标字段</span>
    </p>

    <label>
      <div class="modelApplyScreen">
        <label>下载模板：</label>
        <a :href="template1" class="downLoad">面积模板</a>
        <a :href="template2">产量模板</a>
      </div>
      <div class="modelApplyScreen">
        <label>预测步长：</label>
        <el-input v-model="number" placeholder="请输入步长"></el-input>
      </div>
      <div class="modelApplyScreen">
        <label>上传数据：</label>
        <el-input v-model="localFileName" placeholder="请选择文件" :readonly="readonly" />
        <span class="screen-upload-btn">
          <input type="file" accept=".xls, .xlsx" @change="uploadFileBtn" class="inputFile" />
          <!-- <a href="http://39.98.159.27:8080/image/model/model/%E4%BA%A7%E9%87%8F.xlsx">
            <i class="el-icon-download"></i>
          数据下载
          </a>-->

          <i class="el-icon-upload2"></i>
          数据上传
        </span>
      </div>

      <div class="modelApplyScreen">
        <label>数据区域：</label>
        <el-select v-model="localProvinceName" placeholder="选择城市">
          <el-option
            v-for="(item, index) in localProvinceList"
            :key="index"
            :label="item"
            :value="item"
          ></el-option>
        </el-select>
      </div>
      <p style="font-size: 12px; width: 50%; color: red">
        <!-- 注意：选择品种最多选择5类胶类进行预测，超出规定数量将不能显示预测效果 -->
      </p>
    </label>

    <div style="clear: both"></div>
    <p class="modelApplyLittleTitle">
      <span>第2步：</span>
      <span>点击分析查看预测数据指标</span>
      <el-button class="greenBtn" @click="targetClick">分析</el-button>
    </p>
    <div class="modelApplyTable">
      <el-table :data="areaYieldList" border style="width: 100%">
        <el-table-column prop="areaName" label="城市"></el-table-column>
        <el-table-column prop="year" label="年份"></el-table-column>
        <el-table-column prop="totalArea" label="面积（亩）" v-if="totalAreaTag"></el-table-column>
        <el-table-column prop="totalOutputValue" label="产量（吨）" v-if="totalYieldTag"></el-table-column>
      </el-table>
    </div>
    <div style="clear: both"></div>
    <div id="targetChart" class="targetChart"></div>
  </div>
</template>

<script>
import echarts from "../../utils/js/echartsServer";
import {
  getProvinceList,
  getHistoryTableData,
  getTargetChartData,
  localForecastModel,
  uploadFile,
} from "../../utils/api/productForecast";
export default {
  name: "",
  data() {
    return {
      template1: `${this.templateUrl}/面积.xlsx`,
      template2: `${this.templateUrl}/产量.xlsx`,
      readonly: true,
      //城市下拉数据
      provinceList: [],
      //预测指标下拉数据
      targetList: [
        {
          value: "area",
          label: "面积预测",
        },
        {
          value: "yield",
          label: "产量预测",
        },
      ],
      localProvinceList: [], // 本地区域名称
      localProvinceName: "", // 本地区域列表
      provinceName: "", //城市下拉
      targetName: "area", //预测指标下拉
      number: "", //步长
      // 表格历史数据
      historyTableData: [],
      // 预测的数据指标数据
      targetTableData: [],
      currentPage: 1, // 页码
      pageSize: 10, // 每页显示数量
      total: 0, // 总数
      totalAreaTag: true,
      totalYieldTag: false,
      XData: [], //图表X轴
      YData: [], //图表y轴
      dataSoruce: "history",
      localFileName: "", // 文件名称
      localFileUrl: "", // 文件流
      areaYieldList: [], // 第三步  预测 表格数
      // 数据来源数据
      dataSoruceList: [
        {
          label: "本地数据",
          value: "local",
        },
        {
          label: "历史数据",
          value: "history",
        },
      ],
    };
  },
  methods: {
    // 数据来源change
    dataSoruceChange(value) {
      // 切换数据来源 初始化查询条件
      this.localFileName = ""; // 文件名称清空
      this.localFileUrl = ""; // 文件路径清空\
      this.number = ""; // 步长清空
      this.areaYieldList = []; // 最后一步预测 列表数据清空
      let yearList = [];
      let realList = [];
      let forecastList = [];
      let echartsData = {
        yearList,
        realList,
        forecastList,
      };
      echarts.getTargetChart("targetChart", echartsData);
      // 历史数据 地区默认显示列表第一个
      // if (value === "history") {
      //   this.provinceValue = this.provinceList[0];
      // } else {
        this.provinceValue = "";
      // }
    },
    // 获取城市列表
    async getProvinceList() {
      const res = await getProvinceList();
      if (res.data.code === 0) {
        this.provinceList = res.data.data;
        this.provinceName = this.provinceList[0]; // 默认省名称为列表第一个
        this.getHistoryTableData(); // 获取历史列表数据
      } else if (res.data.code !== 0) {
        this.$message({
          message: res.data.msg,
          type: "warning",
        });
      }
    },
    // 城市change
    provinceChange(val) {
      this.provinceName = val;
    },
    // 预测指标change
    targetChange(val) {
      this.targetName = val;
      if (val === "area") {
        this.totalAreaTag = true;
        this.totalYieldTag = false;
      }
      if (val === "yield") {
        this.totalAreaTag = false;
        this.totalYieldTag = true;
      }
    },
    // 获取历史列表数据
    async getHistoryTableData() {
      let params = {
        currentPage: this.currentPage,
        pageSize: this.pageSize,
        areaName: this.provinceName, //城市
      };
      let res = await getHistoryTableData(params);
      if (res.data.code === 0) {
        this.historyTableData = res.data.data.records;
        this.total = res.data.data.total;
      }
    },
    // 上传本地文件
    uploadFileBtn(evt) {
      if (!this.number) {
        this.$message({
          message: "请输入预测步长",
          type: "warning",
        });
        return;
      }
      this.localFileName = evt.target.files[0].name;
      this.uploadFile(evt.target.files[0]);
    },
    // 上传文件接口
    async uploadFile(file) {
      let formdata = new FormData();
      formdata.append("file", file);
      let res = await uploadFile(formdata);
      this.localFileUrl = res.data;
      this.getAreaListByFile();
    },
    // 分页
    // historyCurrentChange(value) {
    //   this.currentPage = value;
    //   this.getHistoryTableData();
    // },
    // 查询按钮
    // async queryClick() {
    //   this.getHistoryTableData();
    // },
    //获取图表数据
    async getTargetChartData() {
      if (!this.number) {
        this.$message({
          message: "请输入预测步长",
          type: "warning",
        });
        return;
      }
      let params = {
        areaName: this.provinceName, //城市
        number: this.number, //步长
        type: this.targetName, //类型：yield产量，area面积
      };
      let res = await getTargetChartData(params);
      if (res.data.code === 0) {
        this.areaYieldList = res.data.data.areaYieldList; // 预测第三步 数据
        let yearList = [];
        yearList = res.data.data.yearList;
        let forecastList = [];
        forecastList = res.data.data.forecastList;
        let realList = [];
        realList = res.data.data.realList;
        let echartsData = {
          yearList,
          forecastList,
          realList,
        };
        echarts.getTargetChart("targetChart", echartsData);
      }
    },
    // 分析按钮
    async targetClick() {
      // if (this.dataSoruce === "history") {
      //   this.getTargetChartData();
      // } else {
        this.localForecastModel();
      // }
    },
    // 根据上传文件 获取 地区列表
    async getAreaListByFile() {
      let params = {
        file: this.localFileUrl,
        step: this.number,
      };
      let res = await localForecastModel(params);
      if (res.data.code === 0) {
        this.localProvinceList = res.data.data.areaList;
        if (res.data.data.dataType === "面积") {
          this.targetName = "area";
          this.totalAreaTag = true;
          this.totalYieldTag = false;
        } else if (res.data.data.dataType === "产量") {
          this.targetName = "yield";
          this.totalAreaTag = false;
          this.totalYieldTag = true;
        }
      }
    },
    // 本地预测接口
    async localForecastModel() {
      if (!this.number) {
        this.$message({
          message: "请输入预测步长",
          type: "warning",
        });
        return;
      }
      // else if (!this.localProvinceName) {
      //   this.$message({
      //     message: "请选择数据区域",
      //     type: "warning",
      //   });
      //   return;
      // }
      let params = {
        file: this.localFileUrl,
        step: this.number,
        area: '福安' // this.localProvinceName,
      };
      let res = await localForecastModel(params);
      if (res.data.code === 0) {
        let data = res.data.data;
        for(let i = 0; i<data.length-1;i++){
          for(let j = 0;j<data[i].dataList.length;j++){
            this.areaYieldList.push(data[i].dataList[j])
          }
        }
        this.areaYieldList = data[0].dataList;
        let yearList = [];
        yearList = data[0].yearList;
        let forecastList = [];
        forecastList = data[0].forecastDataList;
        let realList = [];
        realList = data[0].realList;
        let echartsData = {
          yearList,
          forecastList,
          realList,
          unit:`${this.totalAreaTag?'亩':'吨'}`
        };
        echarts.getTargetChart("targetChart", echartsData);
        // let XData = [];
        // XData = res.data.data.yearList;
        // let YData = [];
        // YData1 = res.data.data.realList; // 真实列表
        // YData2 = res.data.data.forecastList; // 预测列表
        // let echartsData = {
        //   XData,
        //   YData1,
        //   YData2
        // };
        // echarts.getTargetChart("targetChart", echartsData);
      }
    },
    // 切换本地区域列表
    // localProvinceChange(value){
    //   this.localProvinceName = value;
    //   this.localForecastModel(); // 预测
    // }
  },
  mounted() {
    // this.getProvinceList();
    // this.getHistoryTableData();
    //  this.getTargetChartData();
  },
};
</script>

<style lang="scss" scoped>
.model_continer{
  margin-left: 30px;
}
.introl {
  color: #999;
  font-size: 14px;
  line-height: 22px;
  margin-top: 10px;
}

.modelApplyLittleTitle {
  margin: 20px 0;
  font-size: 16px;
}
.modelApplyLittleTitle span:nth-child(1) {
  font-weight: bold;
}
.modelApplyLittleTitle span:nth-child(2) {
  color: #333;
}
.modelApplyScreen {
  display: inline-block;
  margin-right: 15px;
  margin-bottom: 15px;
  label {
    color: #999;
  }
  a {
    color: #333;
    font-size: 14px;
    text-decoration: underline;
  }
  .downLoad {
    margin-right: 5px;
  }
}
.greenBtn {
  padding: 6px 12px;
  font-size: 16px;
  letter-spacing: 1px;
  background: #59a6a0;
  border: 1px solid #59a6a0;
  color: #fff;
  margin-left: 30px;
}
.greenBtn:focus,
.greenBtn:hover {
  background: #39a1a6;
  border: 1px solid #39a1a6;
}
.targetChart {
  margin-top: 10px;
  width: 100%;
  height: 400px;
}
.screen-upload-btn {
  width: 100px;
  margin-bottom: 0;
  margin-top: 0;
  position: relative;
  font-size: 14px;
  color: #999;
  .inputFile {
    position: absolute;
    width: 100px;
    left: 0px;
    height: 30px;
    opacity: 0;
  }
}
.dataAnalysisTitle{
  font-size: 18px;
}
</style>
